import { FC, useEffect } from 'react';
import { useLocation } from 'react-router';
import { Container, Flex, Link } from '@qga/roo-ui/components';
import { themeGet } from '@styled-system/theme-get';
import styled from '@emotion/styled';
import { rem } from 'polished';
import login from './utils/login';
import logout from './utils/logout';
import { qantasHotelsLight } from '@qga/roo-ui/logos';
import { CONTACT_US_URL } from 'config/constants';
import { EDS_ENV, HOTELS_BASE_URL } from 'config';

const CharcoalNavBar = styled(Flex)`
  color: ${themeGet('colors.white')};
  background-color: ${themeGet('colors.greys.charcoal')};
`;

const LinkLogoContainer = styled(Flex)`
  justify-content: space-between;
  align-items: flex-end;

  @media print {
    display: none;
  }
`;

const Logo = styled.img`
  display: inline-flex;
  width: ${rem(186)};
`;

declare global {
  interface Window {
    oauth?: {
      login?: (...args: unknown[]) => void;
      logout?: (...args: unknown[]) => void;
      [key: string]: unknown;
    };
  }
}

const EdsHeader: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const overrideOauth = () => {
      window.oauth ??= {};
      window.oauth.login = () => login(pathname);
      window.oauth.logout = () => logout();
    };

    overrideOauth();

    const observer = new MutationObserver(() => {
      overrideOauth();
    });

    observer.observe(document.head, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [pathname]);

  return (
    <>
      <header
        data-testid="eds-block"
        className="eds-block"
        data-env={EDS_ENV}
        data-helplink={CONTACT_US_URL}
        data-langregion="en-au"
        data-hide-region="true"
        data-hide-cart="true"
        data-hide-login="false"
        data-skiptoelements="false"
      />
      <CharcoalNavBar>
        <Container>
          <LinkLogoContainer>
            <Link href={HOTELS_BASE_URL} title="Qantas Hotels" aria-label="Qantas Hotels" mr={4} my={2} p={1}>
              <Logo src={qantasHotelsLight} alt="Qantas" role="img" aria-label="Qantas Logo" />
            </Link>
          </LinkLogoContainer>
        </Container>
      </CharcoalNavBar>
    </>
  );
};

export default EdsHeader;
